<template>
  <div class="license-openid">
    <el-card class="query-card">
      <div slot="header" class="card-header">
        <h2>SN OpenID 查询</h2>
      </div>

      <el-form label-position="top" @submit.native.prevent>
        <el-form-item label="设备 SN">
          <div class="query-row">
            <el-input
              v-model.trim="sn"
              placeholder="请输入设备 SN"
              clearable
              @keyup.enter.native="queryOpenId">
            </el-input>
            <el-button
              type="primary"
              icon="el-icon-search"
              :loading="loading"
              :disabled="!sn"
              @click="queryOpenId">查询</el-button>
          </div>
        </el-form-item>
      </el-form>

      <el-alert
        v-if="errorMsg"
        class="result-alert"
        :title="errorMsg"
        type="error"
        show-icon
        :closable="false">
      </el-alert>

      <div v-if="result" class="result-panel">
        <div class="result-line">
          <span class="result-label">code</span>
          <span class="result-value">{{ result.code }}</span>
        </div>
        <div class="result-line">
          <span class="result-label">msg</span>
          <span class="result-value">{{ result.msg || '-' }}</span>
        </div>
        <div v-if="openId" class="result-line primary">
          <span class="result-label">openId</span>
          <span class="result-value selectable">{{ openId }}</span>
          <el-button
            size="mini"
            icon="el-icon-document-copy"
            @click="copyText(openId)">复制</el-button>
        </div>
        <pre class="raw-json">{{ formattedResult }}</pre>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryOpenIdBySn } from 'network/licenseOpenId'

export default {
  name: 'LicenseOpenId',
  data() {
    return {
      sn: '',
      loading: false,
      result: null,
      errorMsg: ''
    }
  },
  computed: {
    openId() {
      return this.result && this.result.data ? this.result.data.openId : ''
    },
    formattedResult() {
      return this.result ? JSON.stringify(this.result, null, 2) : ''
    }
  },
  methods: {
    async queryOpenId() {
      const sn = this.sn.trim()
      if (!sn) {
        this.$message.warning('请输入设备 SN')
        return
      }

      this.loading = true
      this.errorMsg = ''
      this.result = null
      try {
        const result = await queryOpenIdBySn(sn)
        this.result = result
        if (result.code === 0 && this.openId) {
          this.$message.success('查询成功')
        } else {
          this.errorMsg = `查询失败：${result.msg || '未返回 openId'}`
        }
      } catch (err) {
        console.error(err)
        this.errorMsg = this.resolveErrorMessage(err)
      } finally {
        this.loading = false
      }
    },
    resolveErrorMessage(err) {
      if (err.response && err.response.data) {
        const data = err.response.data
        if (typeof data === 'string') return data
        if (data.msg) return `查询失败：${data.msg}`
      }
      if (err.message) return `查询失败：${err.message}`
      return '查询失败，请检查网络后重试'
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text)
        this.$message.success('已复制')
      } catch (err) {
        console.error(err)
        this.$message.error('复制失败')
      }
    }
  }
}
</script>

<style scoped>
.license-openid {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: calc(100vh - 60px);
  padding: 48px 24px;
  background: #f5f7fb;
}
.query-card {
  width: 100%;
  max-width: 840px;
  border-radius: 8px;
}
.card-header h2 {
  margin: 0;
  color: #17233d;
  font-size: 24px;
  font-weight: 600;
}
.query-row {
  display: flex;
  gap: 12px;
}
.query-row .el-button {
  flex: 0 0 112px;
}
.result-alert {
  margin-top: 18px;
}
.result-panel {
  margin-top: 22px;
  padding: 20px;
  background: #fbfcff;
  border: 1px solid #e4e8f1;
  border-radius: 8px;
}
.result-line {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  min-height: 36px;
  color: #303133;
}
.result-line + .result-line {
  border-top: 1px solid #edf0f6;
}
.result-line.primary {
  color: #0b5cad;
  font-weight: 600;
}
.result-label {
  color: #7a8494;
}
.result-value {
  overflow-wrap: anywhere;
}
.selectable {
  user-select: all;
}
.raw-json {
  margin: 18px 0 0;
  padding: 14px;
  overflow: auto;
  color: #27364a;
  background: #f0f3f8;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.6;
}
@media (max-width: 750px) {
  .license-openid {
    padding: 24px 12px;
  }
  .query-row {
    display: block;
  }
  .query-row .el-button {
    width: 100%;
    margin-top: 12px;
  }
  .result-line {
    grid-template-columns: 72px minmax(0, 1fr);
  }
  .result-line .el-button {
    grid-column: 2;
    justify-self: flex-start;
  }
}
</style>
